import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import {
  ColumnsPanelTrigger,
  ExportCsv,
  FilterPanelTrigger,
  GridColumnIcon,
  GridDownloadIcon,
  GridFilterListIcon,
  QuickFilter,
  QuickFilterControl,
  Toolbar,
  ToolbarButton,
} from '@mui/x-data-grid';
import type { ToolbarPropsOverrides } from '@mui/x-data-grid';

import { QuickFilterSearchField } from './QuickFilterSearchField';
import type { QuickFilterSearchFieldProps } from './QuickFilterSearchField';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    readonly groupActions?: ReactNode;
  }
}

const renderQuickFilterControl = (
  controlProps: Readonly<Omit<QuickFilterSearchFieldProps, 'state'>>,
  state: QuickFilterSearchFieldProps['state'],
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <QuickFilterSearchField {...controlProps} state={state} />;

type Props = Pick<ToolbarPropsOverrides, 'groupActions'>;

export const DefaultToolbar = ({ groupActions }: Readonly<Props>) => (
  <Toolbar>
    <Tooltip title="Colonnes">
      <ColumnsPanelTrigger render={<ToolbarButton />}>
        <GridColumnIcon fontSize="small" />
      </ColumnsPanelTrigger>
    </Tooltip>
    <Tooltip title="Filtres">
      <FilterPanelTrigger render={<ToolbarButton />}>
        <GridFilterListIcon fontSize="small" />
      </FilterPanelTrigger>
    </Tooltip>
    <Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 1 }} />
    <Tooltip title="Exporter">
      <ExportCsv render={<ToolbarButton />}>
        <GridDownloadIcon fontSize="small" />
      </ExportCsv>
    </Tooltip>
    <Box sx={{ flex: 1 }} />
    {groupActions}
    <QuickFilter defaultExpanded>
      <QuickFilterControl render={renderQuickFilterControl} />
    </QuickFilter>
  </Toolbar>
);
